export default __webpack_public_path__ + "static/media/foodbank_2.c2981098.png";